import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'redux/selectors';

export const useTableRows = ({ companies, sharedList, network, contactsSource, isActiveSync }) => {
  const user = useSelector(userSelector);

  const formatRow = useCallback(
    (company) => {
      const isIntroOffered = !!company?.contact?.intros?.find((intro) => intro.offererId === user?.id);
      return {
        getRowHeight: () => (isIntroOffered ? 100 : 50),
        contactsSource,
        network,
        isIntroOffered,
        isActiveSync,
        original: company,
        isPublicList: true,
        isGroup: Boolean(company.groupIndex),
        sharedList,
        rowId: company.rowId,
        importers: company?.importers ?? [],
        id: company.id,
        name: company.name,
        contactsCount: company.groupIndex ? company.contactsCount : 'exclude',
        contactName: company?.contact?.fullName,
        jobTitle: company?.contact?.targetPositions?.find((position) => position.active)?.jobTitle,
        contactOf: company?.contact?.importers ?? [],
        offerIntro: '',
      };
    },
    [contactsSource, isActiveSync, network, sharedList, user?.id],
  );

  return useMemo(() => companies.map(formatRow), [companies, formatRow]);
};
